<template>
  <div class="survey-box">
    <h3 class="survey-title">{{ categoryInfo.CategoryName }}</h3>
    <div class="survey">

      <div
        v-if="questionList.length === 0"
        class="question"
      >
        <div class="question-title">
          <div>
            工单内容
          </div>
        </div>
        <el-input
          type="textarea"
          :rows="14"
          placeholder="请输入内容"
          v-model="Notes"
        >
        </el-input>
      </div>
      <div
        v-else
        class="question"
        v-for="question in questionList"
        v-show="!question.isHide && !question.is_hide"
        :key="question.id"
      >
        <div
          class="question-title"
          v-if="
            question.control_type !== 'CustomProduct' && 
            question.control_type !== 'ChannelAndLevel2' &&
            question.control_type !== 'VoucherImage' 
            "
        >
          <div style="display: flex;">
            <h4
              class="question-title-big"
              v-if="question.control_type === 'Title'"
            >
              {{ question.label }}
            </h4>
            <span v-else>
              {{ question.label }}
            </span>
            <span
              class="question-title-require"
              v-if="question.required"
            >
              *
            </span>
          </div>
        </div>
        <reserveTime
          v-if="question.control_type === 'CustomAppointmentPlan'"
          :question="question"
          @answerChange="answerChange"
        />
        <customer
          v-if="question.control_type === 'HisCustomerEdit'"
          :question="question"
          @answerChange="answerChange"
        />
        <fill
          v-if="question.control_type === 'TextBox'"
          :question="question"
          @answerChange="answerChange"
        />
        <multipleFill
          v-if="question.control_type === 'Memo'"
          :question="question"
          @answerChange="answerChange"
        />
        <radio
          v-if="question.control_type === 'Radio'"
          :question="question"
          @answerChange="answerChange"
        />
        <radioKey
          v-if="question.control_type === 'CustomComplaintDealGroup'"
          :question="question"
          @answerChange="answerChange"
        />
        <payType
          v-if="question.control_type === 'CustomPayType'"
          :question="question"
          @answerChange="answerChange"
        />

        <checkbox
          v-if="question.control_type === 'CheckBox'"
          :question="question"
          @answerChange="answerChange"
        />
        <datePicker
          v-if="question.control_type === 'DatePicker'"
          :question="question"
          @answerChange="answerChange"
        />
        <dateTimePicker
          v-if="question.control_type === 'DatetimePicker'"
          :question="question"
          @answerChange="answerChange"
        />
        <remark
          v-if="question.control_type === 'remark'"
          :question="question"
          @answerChange="answerChange"
        />
        <upload
          v-if="question.control_type === 'upload'"
          :question="question"
          @answerChange="answerChange"
        />
        <tips
          v-if="question.control_type === 'Tips'"
          :question="question"
          @answerChange="answerChange"
        />
        <customAgent
          v-if="question.control_type === 'CustomAgent'"
          :question="question"
          @answerChange="answerChange"
        />
        <customDoctor
          v-if="question.control_type === 'CustomDoctor'"
          :question="question"
          @answerChange="answerChange"
        />
        <discount
          v-if="question.control_type === 'CustomDiscount'"
          :question="question"
          @answerChange="answerChange"
        />
        <services
          v-if="question.control_type === 'CustomService'"
          :question="question"
          @answerChange="answerChange"
        />
        <customMDTSpecialist
          v-if="question.control_type === 'CustomMDTSpecialist'"
          :question="question"
          @answerChange="answerChange"
        />
        <tijianPackage
          v-if="question.control_type === 'CustomTijianPackage'"
          :question="question"
          @answerChange="answerChange"
        />
        <channel
          v-if="question.control_type === 'scrm_lingdang'"
          :question="question"
          @answerChange="answerChange"
        />
        <dateTimePickerHis
          v-if="question.control_type === 'DatetimePickerHis'"
          :question="question"
          @answerChange="answerChange"
        />
        <product
          :questionList="questionList"
          v-if="question.control_type === 'CustomProduct'"
          :question="question"
          @answerChange="answerChange"
          ref="product"
        />
        <selectTree
          v-if="question.control_type === 'MultiChannel23'"
          :question="question"
          @answerChange="answerChange"
        />
        <picker
          v-if="question.control_type === 'DropdownList'"
          :question="question"
          @answerChange="answerChange"
        />
        <channelAndLevel
          v-if="question.control_type === 'ChannelAndLevel2'"
          :question="question"
          @answerChange="answerChange"
        />
        <paymentReceipt
          v-if="question.control_type === 'VoucherImage'"
          :question="question"
          :payMethod="'weixin'"
          :showAmountTip="question.showAmountTip"
          @answerChange="answerChange"
          ref="paymentReceipt"
        />

      </div>

      <div
        class="question"
        v-if="categoryInfo.IsAttachment"
      >
        <div class="question-title">
          <div>
            上传附件
            <span
              class="question-title-require"
              v-if="isOrderSubmitted"
            >
              *
            </span>
          </div>
        </div>
        <upload @change="fileChange" />
      </div>

      <div
        class="question"
        v-if="categoryInfo.IsProcessGroup"
        v-show="$route.query.source !== 'qr'"
      >
        <div class="question-title">
          <div>
            选择处理组
            <span class="question-title-require">
              *
            </span>
          </div>
        </div>
        <processGroup
          :defaultValue="$route.query.group ? $route.query.group.split(',') : categoryInfo.DefaultProcessGroup"
          :optionList="workProcessGroupList"
          @change="(value) => workProcessGroup = value"
        />
      </div>
      <div class="survey-btn">
        <el-button
          type="primary"
          @click="submit"
          size="small"
          :loading="submitting"
        >提交</el-button>
      </div>
    </div>

  </div>

</template>

<script>
import customer from "./components/cuotomer.vue";
import upload from "./components/upload.vue";
import fill from "./components/fill.vue";
import radio from "./components/radio.vue";
import radioKey from "./components/radioKey.vue";
import remark from "./components/remark.vue";
import datePicker from "./components/datePicker.vue";
import dateTimePicker from "./components/dateTimePicker.vue";
import dateTimePickerHis from "./components/dateTimePickerHis.vue";
import checkbox from "./components/checkbox.vue";
import multipleFill from "./components/multipleFill.vue";
import processGroup from "./components/processGroup.vue";
import customAgent from "./components/customAgent.vue";
import customDoctor from "./components/customDoctor.vue";
import discount from "./components/discount.vue";
import services from "./components/services.vue";
import customMDTSpecialist from "./components/customMDTSpecialist.vue";
import tijianPackage from "./components/tijianPackage.vue";
import reserveTime from "./components/reserveTime.vue";
import payType from "./components/payType.vue";
import channel from "./components/channel.vue";
import product from "./components/product.vue";
import selectTree from "./components/selectTree.vue";
import picker from "./components/picker.vue";
import channelAndLevel from "./components/channelAndLevel.vue";
import paymentReceipt from "./components/paymentReceipt";

import tips from "./components/tips.vue";
import workService from "@/apis/work/index.js";
import { Message } from "element-ui";
import cuotomerService from "@/apis/customer/index.js";
import complaintService from "@/apis/complaint/index.js";
import menZhenService from "@/apis/menZhen/index.js";
import idCardTool from "@/utils/idCard.js";
import { Dialog } from "vant";
import getUserInfo from "@/models/userInfo";
import getDdCode from "@/models/ddCode";
import { transformUrl, deepClone } from "@/utils/utils";
import { Toast } from "vant";

// import * as dd from "dingtalk-jsapi";

export default {
  components: {
    customer,
    upload,
    fill,
    multipleFill,
    radio,
    radioKey,
    remark,
    datePicker,
    checkbox,
    dateTimePicker,
    dateTimePickerHis,
    processGroup,
    tips,
    customAgent,
    customDoctor,
    discount,
    services,
    customMDTSpecialist,
    tijianPackage,
    reserveTime,
    payType,
    channel,
    product,
    selectTree,
    picker,
    channelAndLevel,
    paymentReceipt,
  },
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: "80px",
      cuotomerForm: {},
      cuotomerInfo: {},
      questionList: [],
      categoryInfo: {},
      workProcessGroupList: [],
      fileList: [],
      workProcessGroup: [],
      currentUserInfo: {},
      Notes: "",
      submitting: false,
      hisPatientEnumsMap: {},
      dingCode: "",
      firstSubmit: true,
      isOrderSubmitted: false,
    };
  },
  async created() {},
  mounted() {
    this.init();
  },
  methods: {
    // async getWorkDingAuth() {
    //   const userInfo = await getUserInfo();
    //   this.userInfo = userInfo;
    // },
    async init() {
      const query = this.$route.query;
      let userInfo = {};
      this.$store.dispatch("customer/setCustomerInfo", {});

      if (query.source === "qr") {
        // this.isOrderSubmitted = true;
        if (document.querySelector(".el-menu-yuanhe")) {
          document.querySelector(".el-menu-yuanhe").style.display = "none";
        }
        userInfo = await this.workUserGet();
      } else if (query.duid) {
        userInfo = await this.workUserGet();
      } else {
        userInfo = await getUserInfo();
      }
      // await this.getWorkDingAuth();

      this.currentUserInfo = userInfo;
      this.hisPatientEnums();
      this.getWorkAddControl();
      this.getWorkProcessGroup();
    },
    async workUserGet() {
      const query = this.$route.query;
      const params = {
        ding_user_id: query.duid,
      };
      return workService.workUserGet(params).then((res) => {
        return {
          ...res,
          ding_user_id: res.DingUserId,
          mobile: res.UserPhone,
          position: res.UserPosition,
          user_id: res.UserId,
          user_name: res.UserName,
        };
      });
    },
    async submit() {
      const {
        currentUserInfo,
        Notes,
        fileList,
        workProcessGroup,
        categoryInfo,
        isOrderSubmitted,
      } = this;
      const query = this.$route.query;
      let { questionList } = this;
      let cuotomerInfo = "";
      let errorMsg = "";
      let Inputs = [];
      questionList = JSON.parse(JSON.stringify(questionList));
      if (questionList.length === 0) {
        console.log("不许校验");
      } else if (
        questionList.some((question) => {
          if (question.required && !question.isHide) {
            if (
              !question.answer ||
              (typeof question.answer === "string" &&
                question.answer.trim() === "")
            ) {
              errorMsg = `请完成${question.label}`;
              // Message({
              //   message: `请完成${question.label}`,
              //   type: "warning",
              // });
              return true;
            }
          }
          // todo:正则校验
          if (question.regex && question.answer) {
            if (!eval(question.regex).test(question.answer)) {
              errorMsg = `请正确完成${question.label}`;

              // Message({
              //   message: `请正确完成${question.label}`,
              //   type: "warning",
              // });
              return true;
            }
          }
          // 增值服务校验
          if (
            question.control_type === "CustomService" &&
            question.answer.is_service == 1 &&
            question.answer.service_list?.length === 0
          ) {
            errorMsg = `请完成${question.label}`;

            return true;
          }
          // 体检套餐
          if (question.control_type === "CustomTijianPackage") {
            // if (!question.answer.product_id) {
            //   errorMsg = `请完成${question.label}`;
            //   return true;
            // }
            if (
              question.answer.tj_package_type == 1 &&
              (!question.answer.tj_fee_start || !question.answer.tj_fee_end)
            ) {
              errorMsg = `请完成${question.label}`;
              return true;
            } else if (
              question.answer.tj_package_type == 2 &&
              !question.answer.tj_package_id
            ) {
              errorMsg = `请完成${question.label}`;
              return true;
            }
          }
          // 挂账机构
          if (
            question.control_type === "CustomPayType" &&
            question.field_id === "tj_pay_type" &&
            question.answer.value === "挂账机构" &&
            !question.answer.tj_companyId
          ) {
            errorMsg = `请完成${question.label}`;
            return true;
          }
          // 产品下单
          if (
            question.control_type === "CustomProduct" &&
            question.answer.data.some(
              (address) =>
                !address.address ||
                address.products.some(
                  (prodcut) => !Number.isFinite(prodcut.total)
                )
            )
          ) {
            errorMsg = `请完成${question.label}`;
            return true;
          }
          // 渠道+二级机构
          if (question.control_type === "ChannelAndLevel2") {
            if (!question.answer.channel) {
              errorMsg = `请完成渠道`;
              return true;
            } else if (!question.answer.org) {
              errorMsg = `请完成二级机构`;
              return true;
            }
          }

          // 凭证图片
          if (question.control_type === "VoucherImage") {
            if (
              (!question.answer || question.answer.length == 0) &&
              !question.isHide
            ) {
              errorMsg = `请上传凭证图片`;
              return true;
            }
            // if (question.answer.some((item) => item.tradeNo.length != 28)) {
            //   errorMsg = `交易单号为28位数字，请手动补全/修改`;
            //   return true;
            // }
          }
          // 是否享受折扣
          if (question.control_type === "CustomDiscount") {
            if (question.answer.is_discount == "1") {
              // 折扣方式必填
              if (
                !question.answer.discountValue &&
                !question.answer.reducetValue &&
                !question.answer.settlementValue
              ) {
                errorMsg = `请填写完整折扣信息`;
                return true;
              }
            }
          }
          // 付费方式
          if (question.control_type === "CustomPayType") {
            if (question.answer.value === "挂账机构") {
              if (!question.answer.tj_companyId) {
                errorMsg = `请填写挂账公司`;
                return true;
              }
            }
          }
        })
      ) {
        if (errorMsg) {
          Message({
            message: errorMsg,
            type: "warning",
          });
          return;
        }
        console.log("未完成");
      } else if (
        fileList.some((file) => {
          return file.status !== "success";
        })
      ) {
        Message({
          message: `请正确等待文件上传完成后再提交`,
          type: "warning",
        });
        return true;
      } else if (workProcessGroup.length === 0 && categoryInfo.IsProcessGroup) {
        Message({
          message: `请选择处理组`,
          type: "warning",
        });
        return;
      } else {
        // 特殊处理渠道+二级机构
        questionList.forEach((question) => {
          if (question.control_type === "ChannelAndLevel2") {
            questionList.forEach((innerQuestion) => {
              if (innerQuestion.field_id === "channel") {
                innerQuestion.answer = question.answer.channel;
              } else if (innerQuestion.field_id === "level2") {
                innerQuestion.answer = question.answer.org;
              }
            });
          }
        });

        questionList.forEach((question) => {
          if (question.answer) {
            let answer = {};
            answer = {
              control_type: question.control_type,
              key: question.field_id,
              label: question.label,
              value: question.answer,
            };

            if (question.control_type === "CheckBox") {
              answer.value = question.answer.join(",");
            } else if (question.control_type === "HisCustomerEdit") {
              cuotomerInfo = question.answer;
              answer.value = JSON.stringify(cuotomerInfo);
            } else if (question.control_type === "CustomTijianPackage") {
              answer.value = JSON.stringify(question.answer);
            } else if (question.control_type === "CustomAgent") {
              if (question.answer.require) {
                if (!question.answer.name) {
                  errorMsg = "请输入正确的推荐人姓名";
                } else if (
                  !/^1(3|4|5|6|7|8|9)\d{9}$/.test(question.answer.tel)
                ) {
                  errorMsg = "请输入正确的推荐人手机号";
                } else if (
                  !/^[\u4e00-\u9fa5]|[a-zA-Z]$/.test(question.answer.name)
                ) {
                  errorMsg = "请输入正确的推荐人姓名";
                }
              }
              answer.value = `${
                question.answer.require
                  ? `是。姓名${question.answer.name},手机号${question.answer.tel}`
                  : "否"
              }。`;
            } else if (question.control_type === "CustomDoctor") {
              // 医生信息
              const value = question.answer;
              answer.value = value.reduce((total, item) => {
                return (
                  total +
                  `
                姓名：${item.doctor_name}；
                职称：${item.doctor_title_name}；
                科室：${item.doctor_department_names}；
                医院：${item.hospital_name}；
                看诊费：${item.fee}；
                看诊费备注：${item.fee_remark}；
              `
                );
              }, "");
            } else if (question.control_type === "CustomService") {
              const value = question.answer;
              question.answer.service_list = value.service_list.join(",");
              answer.value = JSON.stringify(question.answer);
            } else if (
              question.control_type === "CustomDiscount" ||
              question.control_type === "CustomPayType" ||
              question.control_type === "scrm_lingdang" ||
              question.control_type === "CustomComplaintDealGroup" ||
              question.control_type === "CustomProduct" ||
              question.control_type === "MultiChannel23" ||
              question.control_type === "ChannelAndLevel2" ||
              question.control_type === "VoucherImage" ||
              question.control_type === "CustomComplaintDealGroup" ||
              question.control_type === "CustomAppointmentPlan"
            ) {
              answer.value = JSON.stringify(question.answer);
            }
            // if (question.control_type !== "HisCustomerEdit") {
            Inputs.push(answer);
            // }
          }
        });
        if (isOrderSubmitted && categoryInfo.IsAttachment) {
          if (fileList.length === 0) {
            errorMsg = "请上传附件";
          }
        }
        if (errorMsg) {
          Message({
            message: errorMsg,
            type: "warning",
          });
          return;
        }
      }
      questionList.forEach((question) => {
        // 处理付款凭证
        if (question.control_type === "VoucherImage") {
          question.answer.forEach((item) => {
            fileList.push(item);
          });
        }
      });
      const queryObj = transformUrl(categoryInfo.PostUrl);
      console.log(queryObj);
      const params = {
        WorkType: categoryInfo.WorkTypeId,
        CategoryId: categoryInfo.Id,
        Files: fileList,
        Inputs,
        Notes: questionList.length > 0 ? "" : Notes,
        ContactName: cuotomerInfo && cuotomerInfo.user_name,
        ContactPhone: cuotomerInfo && cuotomerInfo.user_mobile,
        CustomerLevel: cuotomerInfo && cuotomerInfo.user_level,
        SubmitUserId: currentUserInfo.user_id,
        SubmitUser: currentUserInfo.user_name,
        SubmitUserPhone: currentUserInfo.mobile,
        ProcessGroup: workProcessGroup.map((item) => item.Id).join(","),
        ProcessGroupName: workProcessGroup
          .map((item) => item.GroupName)
          .join(","),
        HisUserInfo: cuotomerInfo ? JSON.stringify(cuotomerInfo) : "",
        ...queryObj,
      };

      if (categoryInfo.Id == 129 && this.firstSubmit) {
        this.firstSubmit = false;
        const workParams = {
          customer_id: cuotomerInfo.patientId,
          work_type: "neijing",
        };
        const workRes = await menZhenService.workExist(workParams);
        if (!workRes) {
          Dialog.alert({
            message: `${cuotomerInfo.user_name}的客户信息已在内镜系统，可联系内镜中心处理，避免工单重复提交`,
            title: "提示",
          });
          return;
        }
      }

      Dialog.confirm({
        title: "提示",
        message: `您填写的信息内容验证通过提交后，无法继续更改，您确定要立即提交吗？
          ${
            categoryInfo.IsAttachment
              ? `注意：本次上传的附件数量为${fileList.length}个`
              : ""
          }
          `,
      })
        .then(() => {
          this.submitting = true;
          workService
            .workAdd(params, categoryInfo.PostUrl)
            .then((res) => {
              console.log(res);
              this.submitting = false;
              if (res?.Status && res.Status !== 200) {
                Toast(res.Message);
                return;
              }
              Message({
                message: `提交成功！已通知相关人员，请耐心等待！`,
                type: "success",
              });
              if (
                categoryInfo.PostUrl &&
                (categoryInfo.PostUrl.indexOf("work_type=tijian") !== -1 ||
                  categoryInfo.PostUrl.indexOf("work_type=neiti") !== -1 ||
                  categoryInfo.PostUrl.indexOf("work_type=puke_neiti") !== -1 ||
                  categoryInfo.PostUrl.indexOf("work_type=neijing") !== -1)
              ) {
                console.log(encodeURIComponent(res));
                this.$router.replace({
                  name: "BookingQrCode",
                  query: {
                    work_id: res.work_id,
                    userId: query.duid ? query.duid : "",
                  },
                });
              } else if (query.source === "qr") {
                this.$router.push({
                  name: "BookingSuccess",
                  query: {
                    source: "qr",
                  },
                });
              } else {
                this.$router.push({
                  name: "Home",
                  query: {
                    ...query,
                  },
                });
              }
            })
            .catch(() => {
              this.submitting = false;
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    hisPatientEnums() {
      cuotomerService.hisPatientEnums().then((res) => {
        console.log(res);
        this.hisPatientEnumsMap = res;
      });
    },

    cuotomerIdNumber(value) {
      const { cuotomerForm } = this;
      if (idCardTool.checkIdCardNo(value)) {
        const cardInfo = idCardTool.getIdCardInfo(value);
        cuotomerForm.user_birthday = cardInfo.birthday;
        cuotomerForm.user_sex = cardInfo.gender === "男" ? 1 : 2;
        this.cuotomerForm = {
          ...cuotomerForm,
        };
        this.$refs.cuotomerForm.$forceUpdate();
      }
    },
    getWorkProcessGroup() {
      workService.getWorkProcessGroup().then((res) => {
        this.workProcessGroupList = res;
      });
    },
    async getWorkAddControl() {
      const query = this.$route.query;
      let ddCode = "";
      if (query.source !== "qr" && !query.duid) {
        ddCode = await getDdCode();
      }
      const params = {
        category_id: this.$route.params.id,
        code: ddCode.code,
        ding_user_id: this.$route.query.duid,
      };
      workService.getWorkAddControl(params).then((res) => {
        this.questionListPares(res.Controls);
        this.categoryInfo = res.category;
        res.Controls.forEach((item) => {
          if (item.field_id === "pay_amount") {
            item.isHide = true;
          }
          if (item.field_id === "voucher_image") {
            item.showAmountTip = true;
            item.isHide = true;
          }
        });
        this.questionList = res.Controls;
        this.Notes = res.category.Remark;
      });
    },
    questionListPares(list) {
      list.forEach((question) => {
        if (question.regex) {
          // question.regex = question.regex.replace(`\\`, `\\\\`);
        }

        if (question.control_type === "CustomComplaintDealGroup") {
          question.optionList = JSON.parse(question.datasource);
        }
        if (
          question.control_type === "Radio" ||
          question.control_type === "CustomPayType" ||
          question.control_type === "DropdownList" ||
          question.control_type === "CheckBox"
        ) {
          question.optionList = question.datasource.split("|");
        } else if (
          question.control_type === "Tips" ||
          question.control_type === "Title"
        ) {
          question.required = 0;
        }
      });
    },
    answerChange({ questionId, answer }) {
      const { categoryInfo, questionList } = this;
      const question = this.getQuestionListById(questionId);
      question.answer = answer;
      if (question.field_id === "complaint_level") {
        this.getGroupsByLevel(question);
      } else if (question.field_id === "customer_type") {
        const levelQuestion = this.getQuestionListByFieldId("complaint_level");
        if (answer === "合作方") {
          levelQuestion.answer = "重大投诉";
        } else {
          levelQuestion.answer = "";
        }
        this.getGroupsByLevel(levelQuestion);
      } else if (question.field_id === "pay_type" && !answer.value) {
        // 内镜不处理
        // 销售下单处理
        // const payAmountQuestion = this.getQuestionListByFieldId("pay_amount");
        const payAmountQuestion = {};
        const voucherImageQuestion =
          this.getQuestionListByFieldId("voucher_image");
        console.log(answer);
        this.$refs.paymentReceipt &&
          this.$refs.paymentReceipt[0] &&
          this.$refs.paymentReceipt[0].reset();

        if (answer.indexOf("现金") !== -1) {
          payAmountQuestion.isHide = false;
          voucherImageQuestion.isHide = false;
        } else {
          payAmountQuestion.isHide = true;
          voucherImageQuestion.isHide = true;
          payAmountQuestion.answer = undefined;
        }
        if (answer.indexOf("现金+挂账") !== -1) {
          voucherImageQuestion.showAmountTip = false;
        } else {
          voucherImageQuestion.showAmountTip = true;
        }
        if (answer.indexOf("挂账") !== -1) {
          this.isOrderSubmitted = true;
        } else {
          this.isOrderSubmitted = false;
        }
      } else if (question.field_id === "channel_and_level2") {
        this.$refs.product && this.$refs.product[0].onLevelChange();
      } else if (categoryInfo.WorkTypeId === "sell_new") {
        if (question.field_id === "channel") {
          questionList.forEach((item) => {
            if (item.field_id === "level2" || item.field_id === "level3") {
              if (answer === "上海解兮生物科技有限公司") {
                item.required = 0;
              } else {
                item.required = 1;
              }
            }
          });
          console.log(answer);
        }
      }
      this.$forceUpdate();
    },
    getGroupsByLevel(question) {
      let complaint_level = "1";
      question.optionList.forEach((option, index) => {
        if (option === question.answer) {
          complaint_level = `${index + 1}`;
        }
      });
      const params = {
        complaint_level,
      };
      complaintService.getGroupsByLevel(params).then((res) => {
        const { questionList } = this;
        questionList.forEach((question) => {
          if (question.field_id === "deal_groups") {
            question.answer = undefined;
            const optionList = [];
            Object.keys(res).forEach((key) => {
              optionList.push({
                key,
                label: res[key],
              });
            });
            question.optionList = optionList;
            if (complaint_level == "3") {
              question.answer = optionList[0];
            }
          }
        });
        this.questionList = deepClone(questionList);
        this.$forceUpdate();
        console.log(res);
      });
    },
    getQuestionListById(questionId) {
      const { questionList } = this;
      let targetQuestion = null;
      questionList.some((question) => {
        if (question.id === questionId) {
          targetQuestion = question;
          return true;
        }
      });
      return targetQuestion;
    },
    getQuestionListByFieldId(fieldId) {
      const { questionList } = this;
      let targetQuestion = null;
      questionList.some((question) => {
        if (question.field_id === fieldId) {
          targetQuestion = question;
          return true;
        }
      });
      return targetQuestion;
    },
    fileChange(fileList) {
      this.fileList = fileList;
    },
  },
};
</script>

<style lang="scss" scoped>
.survey-box {
  background-color: #f5f7fa;
  padding: 1px;
  height: 100%;
  overflow: auto;
}
.survey {
  max-width: 750px;
  margin: 0 auto;
  background-color: #fff;
  padding: 1px 20px;
  box-sizing: border-box;
  min-height: 100vh;
}
.survey-title {
  text-align: center;
  margin: 0;
  background-color: #fff;
  padding: 15px 0;
  max-width: 750px;
  margin: 0 auto;
}
.question {
  margin-bottom: 15px;
}
.survey-btn {
  margin: 20px 0;
}
.van-dialog__message {
  text-align: unset;
}
</style>
<style lang="scss">
.add-customer-dialog {
  .el-dialog {
    min-width: 300px;
  }
  .el-dialog__body {
    padding: 0 20px;
  }
  .el-form-item {
    // margin-bottom: 5px;
  }
}
.question-title {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  .question-title-require {
    color: #e94c2c;
  }
}
.question-title-big {
  margin: 0;
  font-weight: 900;
  font-size: 17px;
}
.survey {
  .van-cell {
    border: 1px solid #dcdfe6;
    border-radius: 5px;
  }
}
</style>